import React, { useState } from 'react';
import PropTypes from 'prop-types';

import cx from '@strava/ui/clsx';

import StravaMediaLightbox from 'components/StravaMediaLightbox';

import styles from './AthleteProfileHeaderMediaGrid.scss';

function AthleteProfileHeaderMediaGrid({ isLoggedIn, items }) {
  const [lightboxState, setLightboxState] = useState({
    isOpen: false,
    selectedIndex: 0
  });

  function handleItemClick(index) {
    setLightboxState({ isOpen: true, selectedIndex: index });
  }

  function getButtonProps(index) {
    if (isLoggedIn) {
      return {
        role: 'button',
        className: styles.button,
        onClick: () => handleItemClick(index),
        onKeyPress: () => handleItemClick(index),
        tabIndex: '0'
      };
    }

    return {
      className: styles.buttonLoggedOut
    };
  }

  const listClassName = (() => {
    if (items.length < 4) {
      return styles.threeUp;
    }
    if (items.length < 5) {
      return styles.fourUp;
    }
    if (items.length < 6) {
      return styles.fiveUp;
    }
    return styles.sixUp;
  })();

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <ul className={cx(styles.list, listClassName)}>
        {items.map((item, index) => (
          <li key={item.photo_id} className={styles.listItem}>
            <div {...getButtonProps(index)}>
              <div
                className={styles.image}
                style={{ backgroundImage: `url(${item.large})` }}
              />
            </div>
          </li>
        ))}
      </ul>

      {lightboxState.isOpen ? (
        <StravaMediaLightbox
          selectedPhotoIndex={lightboxState.selectedIndex}
          photoList={items}
          onCloseRequest={() => {
            setLightboxState({ isOpen: false });
          }}
        />
      ) : null}
    </>
  );
}

AthleteProfileHeaderMediaGrid.defaultProps = {
  items: []
};

AthleteProfileHeaderMediaGrid.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      photo_id: PropTypes.string.isRequired,
      large: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired
    })
  )
};

export default AthleteProfileHeaderMediaGrid;
